import JwtTokenProvider from '@eui-util/jwt-token-provider';
import Vue from 'vue';
import { Dialog } from 'quasar';
import EUIDialog from '@eui-molecule/dialog';
import Router from '../../router';
import routeNames from '../../router/route-names';

export function displayLogoutDialog() {
  if (warningDialog) {
    warningDialog.hide();
    warningDialog = undefined;
  }

  const auth = Vue.prototype.$auth;
  auth.logoutSilently({});
  Vue.nextTick(() => {
    auth.getIsAuthenticated();
  });

  Dialog.create({
    component: EUIDialog,
    label: 'Oops! Your session has expired.',
    message: 'Try logging in again',
    okText: 'Close',
    actionsGrow: true,
    persistent: true,
    displayHideAction: false
  }).onOk(() => {
    // Only action should be to redirect to the logout page
    Router.push({ name: routeNames.logout });
  });
}

let warningDialog;
export function displayLogoutWarningDialog() {
  warningDialog = Dialog.create({
    component: EUIDialog,
    label: 'Your session is about to expire.',
    message:
      'Need more time? You can choose to stay signed in or to log out from the application.',
    okText: 'Stay Signed In',
    cancelText: 'Sign Out',
    persistent: true,
    displayHideAction: false
  })
    .onOk(async () => {
      const auth = Vue.prototype.$auth;
      await auth.getTokenSilently({ ignoreCache: true });
      let token = auth.accessToken;
      jwtTokenProvider.setToken(token);
    })
    .onCancel((a) => {
      if (!jwtTokenProvider.isExpired) {
        // Only action should be to redirect to the logout page
        Router.push({ name: routeNames.logout });
      }
    });
}

export const CALLBACKS = {
  // Called when the token could not be decoded
  onErrorDecode: displayLogoutDialog,
  // Called when there was an error parsing the expiry time
  onErrorParseExpiry: displayLogoutDialog,
  // Called if the token is expired
  onTokenExpired: displayLogoutDialog,
  // Called if the token is within the expiry warning period
  // Currently we do not provide warning functionality
  onTokenExpiryWarning: displayLogoutWarningDialog
};

const jwtTokenProvider = new JwtTokenProvider(CALLBACKS);
export default jwtTokenProvider;
